/** French plural: 0 and 1 are singular */
const s = (count: number) => (count > 1 ? 's' : '');

const en = {
  /** Deletes the item, in its side panel */
  remove: 'Remove',
  title: 'Artists',
  importJson: 'Import JSON',
  add: 'Add artist',
  clearAll: 'Clear all artists',
  search: 'Search artists...',
  artist: 'Artist',
  style: 'Style',
  links: 'Links',
  /** Where and when an artist plays: a column of the list, and a section of the artist's sheet */
  plays: 'Plays',
  empty: 'No artists yet. Add one, or import a JSON file.',
  noMatch: 'No artist matches this search.',
  unknownStage: 'Unknown stage',
  /** The name a new artist starts with */
  newArtistName: 'New Artist',
  edit: 'Edit artist',
  name: 'Name',
  namePlaceholder: 'Artist Name',
  stylePlaceholder: 'Artist Style',
  description: 'Description',
  descriptionPlaceholder: 'Artist Description',
  musicLinks: 'Music links',
  linkLabels: {
    spotify_url: 'Spotify',
    apple_music_url: 'Apple Music',
    youtube_url: 'YouTube',
    soundcloud_url: 'SoundCloud',
    other_url: 'Other',
  },
  linkPlaceholders: {
    spotify_url: 'Spotify URL',
    apple_music_url: 'Apple Music URL',
    youtube_url: 'YouTube URL',
    soundcloud_url: 'SoundCloud URL',
    other_url: 'Other Music URL',
  },
  /** Why a music link is refused. `domain` is the platform's id (spotify, apple, youtube…) */
  linkErrors: {
    scheme: 'URL must start with http:// or https://',
    format: (domain: string) => `Invalid ${domain} URL format`,
    youtubeId: 'Invalid YouTube video ID',
    paths: (domain: string, paths: string) => `${domain} URL must link to ${paths}`,
    params: (domain: string, params: string) => `${domain} URL must include ${params} parameter`,
    invalid: 'Please enter a valid URL',
    example: (examples: string[]) => `Example: ${examples.join(' or ')}`,
  },
  deleteConfirm: (name: string) => `Are you sure you want to delete the artist "${name}"?`,
  deleteTitle: 'Delete artist',
  invalidJson: 'Invalid JSON format. The file must contain an "artists" array.',
  noneValid: 'No valid artists found in the file.',
  /** `refused` artists had the `errors`: an artist can have several */
  importReport: (imported: number, refused: number, errors: string[]) =>
    `Successfully imported ${imported} artists.${refused > 0 ? `\n\n${refused} artists were not imported due to errors:\n${errors.join('\n')}` : ''}`,
  clearAllTitle: 'Clear All Artists',
  clearAllConfirm: (count: number) => `Are you sure you want to delete all ${count} artists? This action cannot be undone.`,
  clearAllButton: 'Clear All',
};

const fr: typeof en = {
  remove: 'Supprimer',
  title: 'Artistes',
  importJson: 'Importer un JSON',
  add: 'Ajouter un artiste',
  clearAll: 'Effacer tous les artistes',
  search: 'Rechercher des artistes...',
  artist: 'Artiste',
  style: 'Style',
  links: 'Liens',
  plays: 'Shows',
  empty: 'Aucun artiste pour l\'instant. Ajoutez-en un, ou importez un fichier JSON.',
  noMatch: 'Aucun artiste ne correspond à cette recherche.',
  unknownStage: 'Scène inconnue',
  newArtistName: 'Nouvel artiste',
  edit: 'Modifier l\'artiste',
  name: 'Nom',
  namePlaceholder: 'Nom de l\'artiste',
  stylePlaceholder: 'Style de l\'artiste',
  description: 'Description',
  descriptionPlaceholder: 'Description de l\'artiste',
  musicLinks: 'Liens musicaux',
  linkLabels: {
    spotify_url: 'Spotify',
    apple_music_url: 'Apple Music',
    youtube_url: 'YouTube',
    soundcloud_url: 'SoundCloud',
    other_url: 'Autre',
  },
  linkPlaceholders: {
    spotify_url: 'URL Spotify',
    apple_music_url: 'URL Apple Music',
    youtube_url: 'URL YouTube',
    soundcloud_url: 'URL SoundCloud',
    other_url: 'URL d\'un autre site',
  },
  linkErrors: {
    scheme: 'L\'URL doit commencer par http:// ou https://',
    format: domain => `Format d'URL ${domain} invalide`,
    youtubeId: 'Identifiant de vidéo YouTube invalide',
    paths: (domain, paths) => `L'URL ${domain} doit pointer vers\u00a0: ${paths}`,
    params: (domain, params) => `L'URL ${domain} doit contenir le paramètre ${params}`,
    invalid: 'Veuillez saisir une URL valide',
    example: examples => `Exemple\u00a0: ${examples.join(' ou ')}`,
  },
  deleteConfirm: name => `Voulez-vous vraiment supprimer l'artiste «\u00a0${name}\u00a0»\u00a0?`,
  deleteTitle: 'Supprimer l\'artiste',
  invalidJson: 'Format JSON invalide. Le fichier doit contenir un tableau «\u00a0artists\u00a0».',
  noneValid: 'Aucun artiste valide dans le fichier.',
  importReport: (imported, refused, errors) =>
    `${imported} artiste${s(imported)} importé${s(imported)}.${refused > 0 ? `\n\n${refused} artiste${s(refused)} non importé${s(refused)} à cause d'erreurs\u00a0:\n${errors.join('\n')}` : ''}`,
  clearAllTitle: 'Effacer tous les artistes',
  clearAllConfirm: count =>
    `Voulez-vous vraiment supprimer ${count > 1 ? `les ${count} artistes` : `${count} artiste`}\u00a0? Cette action est irréversible.`,
  clearAllButton: 'Tout effacer',
};

const messages = { en, fr };
export default messages;
